import { createAnalytics } from '@cfg/ui';

/** Consent-based usage analytics (see @cfg/ui ConsentBanner). */
export const analytics = createAnalytics({
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:4000',
  product: 'kitchen',
});
export const PRIVACY_URL: string | undefined = import.meta.env.VITE_PRIVACY_URL;
